require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/fn/is-iterable.js
// module id = 1003
// module chunks = 0